import React, { useRef, useState, useEffect } from "react";
import clsx from "clsx";
import { Box, FormControlLabel, IconButton, Icons, ListItemText, Menu, MenuItem, Switch } from '@curves/ui-base';

import { ScrollerArrowButton, Tablenization } from "@Local/Components";

import { useCustomerResourceContext } from "@Local/CustomerResource/Components/CustomerResourceContext";
import useCustomerResourceApi from "@Apis/useCustomerResourceApi";
const ActionMenuButton = ({ menuData = [], actionButtonProps = {}, actionMenuProps = {}, textAlign = 'left', enabled = true, ...other }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClickActionButton = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    if (!enabled || menuData.length < 1) return null;
    return (
        <React.Fragment>
            <IconButton {...actionButtonProps} onClick={handleClickActionButton}>
                <Icons.MoreVertical />
            </IconButton>
            <Menu className={clsx('more-label-box-menu', `align-${textAlign}`)} anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
                {menuData.map(({ text, ...others }) => {
                    return (
                        <MenuItem {...others} key={`more_label_${text}`}>
                            <ListItemText>{text}</ListItemText>
                        </MenuItem>
                    );
                })}
            </Menu>
        </React.Fragment>
    );
};
const CustomerResourceEnableSwitch = (props) => {
    const { defaultValue, sourceID } = props;
    const { putCustomerResourceEnableApi } = useCustomerResourceApi();
    const [isEnabled, setIsEnabled] = useState(defaultValue);
    const [isLoading, setIsLoading] = useState(false);
    // 當 defaultValue 改變時更新本地狀態
    useEffect(() => {
        setIsEnabled(defaultValue);
    }, [defaultValue]);
    const handleCustomerResourceEnableApi = async (sourceID, params) => {
        try {
            const resp = await putCustomerResourceEnableApi(sourceID, params);
            if (resp) {
                // 成功後不調用 refresh，保持當前狀態
            }
        } catch (error) {
            // 失敗時恢復原狀態
            setIsEnabled(defaultValue);
        } finally {
            // 重置載入狀態，讓按鈕可以再次點擊
            setIsLoading(false);
        }
    };
    const handleChangeSwitch = (e, checked) => {
        if (isLoading) return;
        setIsEnabled(checked);
        setIsLoading(true);
        const params = { enabled: checked };
        handleCustomerResourceEnableApi(sourceID, params);
    };
    return (
        <FormControlLabel 
            className={'m-0'} 
            control={
                <Switch 
                    checked={isEnabled}
                    onChange={handleChangeSwitch}
                    disabled={isLoading}
                />
            } 
        />
    );
};
const headerRow = [
	{ 
        cellKey: "sort", 
        headerLabel: "順序",
    },
	{ 
        cellKey: "sourceName", 
        headerLabel: "項目名稱",
    },
	{ 
        cellKey: "sourceNote", 
        headerLabel: "項目說明",
    },
	{
		cellKey: "enabled",
		headerLabel: "是否生效",
		align: "center",
		formatCell: (isEnabled, { sourceID }) => {
			return <CustomerResourceEnableSwitch defaultValue={isEnabled} sourceID={sourceID} />;
		},
	},
	{
		cellKey: "more",
		headerLabel: "",
		width: 6.8,
		formatCell: (value, rowData, { openCustomerResourceDialog, refresh }) => {
			const menuData = [
				{
					text: "編輯",
					onClick: e => {
						openCustomerResourceDialog(rowData, refresh);
					},
				},
			];
			return <ActionMenuButton menuData={menuData} />;
		},
	},
];
const CustomerResourceTable = () => {
    const { addDialogRef, refresh, setBookmarkNum, sourceData } = useCustomerResourceContext();
    const { pageIndex = 1, totalPage, list = [] } = sourceData || {};
    const scrollerArrowRef = useRef(null);
    const handleChangePage = (e, num) => {
        if (typeof setBookmarkNum === 'function') setBookmarkNum(num);
    };
    const handleOpenCustomerResourceDialog = (rowData, refresh) => {      
        if (addDialogRef.current && addDialogRef.current.openCustomerResourceDialog) {
            addDialogRef.current.openCustomerResourceDialog(rowData, refresh);
        }
    };
	return (
		<Box className="scroll-arrow-container overview">
			<Tablenization
            cardProps={{ className: 'theme-gray' }}
            page={pageIndex}
            count={totalPage}
            onChange={handleChangePage}
            tableContainerRef={scrollerArrowRef}
            isPagination
            >
				<Tablenization.TableRowHeader 
					headerRow={headerRow} 
					className=""
					cellWidth={null}
				/>
				<Tablenization.TableRowBody
					headerRow={headerRow}
					rowsData={list}
					children={null}
					rowOnClick={() => {}}
					bodyRowHeight={null}
					cellWidth={null}
					alertProps={{ text: '尚無資料' }}
					bodyRowClass={{ key: '', value: '', className: '', fn: null }}
					refresh={refresh}
                    openCustomerResourceDialog={handleOpenCustomerResourceDialog}
				/>
			</Tablenization>
            <ScrollerArrowButton parentRef={scrollerArrowRef} />
		</Box>
	);
};
export default CustomerResourceTable;
